(() => {
  'use strict';
  const SENTINEL = '__CUSTOM_QTY__';
  const roots = new WeakSet();

  function setup(root) {
    if (!root || roots.has(root)) return;
    const productInfo = root.closest('[id^="ProductInfo-"]');
    if (!productInfo) return;
    let product;
    try { product = JSON.parse(root.querySelector('[data-wholesale-product-json]')?.textContent || '{}'); }
    catch { return; }
    if (!product.id || !product.handle || product.vendor !== 'The Talavera Hub' || product.owned !== true) return;
    roots.add(root);
    const quantitySelects = [...productInfo.querySelectorAll('variant-selects select')].filter(select => /bulk discount|quantity/i.test(select.name || ''));
    const requestLink = root.querySelector('[data-wholesale-custom-quantity-link]');
    const destination = () => {
      const url = new URL('/pages/contact', window.location.origin);
      url.hash = 'ContactForm';
      url.searchParams.set('reason', 'wholesale');
      url.searchParams.set('product', String(product.title || ''));
      url.searchParams.set('handle', String(product.handle));
      const productURL = new URL(product.url || `/products/${product.handle}`, window.location.origin);
      if (productURL.origin === window.location.origin) url.searchParams.set('ref', productURL.href);
      const variant = productInfo.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
      const form = variant?.form;
      const quantity = form?.elements?.namedItem('quantity')?.value || productInfo.querySelector('input[name="quantity"]')?.value;
      if (/^[1-9]\d{0,3}$/.test(String(quantity || ''))) url.searchParams.set('qty', quantity);
      return url.href;
    };
    const update = () => {
      const show = root.dataset.wholesalePricingMode === 'regular';
      for (const select of quantitySelects) {
        let option = [...select.options].find(item => item.value === SENTINEL);
        if (show && !option) {
          option = document.createElement('option');
          option.value = SENTINEL;
          option.textContent = 'Looking for custom quantities? Request a quote →';
          select.append(option);
        }
        if (option) { option.hidden = !show; option.disabled = !show; }
      }
      if (requestLink) { requestLink.hidden = true; requestLink.href = destination(); }
    };
    for (const select of quantitySelects) {
      let previousValue = select.value;
      // Intercept this navigation choice before Shopify's variant handler sees it.
      // It is never written into the product form or treated as a purchasable variant.
      select.addEventListener('change', event => {
        if (select.value !== SENTINEL) { previousValue = select.value; return; }
        event.preventDefault();
        event.stopImmediatePropagation();
        select.value = previousValue;
        if (root.dataset.wholesalePricingMode === 'regular') window.location.assign(destination());
      }, true);
    }
    requestLink?.addEventListener('click', () => { requestLink.href = destination(); });
    root.addEventListener('tth:wholesale-variant-state', update);
    update();
  }
  const scan = () => document.querySelectorAll('[data-wholesale-product]').forEach(setup);
  document.addEventListener('tth:wholesale-variant-state', event => setup(event.target));
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
